const RegistrationStates = {
    NotRequired: 'NotRequired',
    Awaiting: 'Awaiting',
    Denied: 'Denied',
    Approved: 'Approved',
}
export default RegistrationStates